import axios from 'axios'

export const state = {
  registrations: null,
}

export const getters = {
  registrations: (state) => state.registrations,
}

export const mutations = {
  SET_REGISTRATIONS(state, registrations) {
    state.registrations = registrations
  },
}

export const actions = {
  fetchAllRegistrations({ commit, state, rootState }, payload) {
    return axios
      .get('/api/registrations', {
        params: payload,
      })
      .then((response) => {
        const registrations = response.data
        commit('SET_REGISTRATIONS', registrations)
        return registrations
      })
  },

  createRegistration(_, payload) {
    return axios.post('/api/registrations', payload)
  },

  updateRegistration(_, payload) {
    return axios.put(`/api/registrations/${payload.id}`, payload)
  },

  deleteRegistration(_, payload) {
    return axios.delete(`/api/registrations/${payload.id}`)
  },
}
